export default __webpack_public_path__ + "static/media/gallery_12.f71bf5d6.jpg";